/**
 * Ableitungen für das Dashboard – Web und Mobil zeigen dieselben Zahlen.
 * Reine Funktionen über der Antwort von `/api/reports/dashboard`.
 */

import { formatPercent } from './format';

/** ISO-Kalenderwoche eines Datums. */
export function isoWeek(date: Date): number {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const day = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - day);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil(((d.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
}

/** Zählreihe der letzten 30 Tage (UTC, wie das Backend) mit Nullen für leere Tage. */
export function dailySeries(rows: any[] | undefined, key: string): number[] {
  const byDay = new Map<string, number>((rows ?? []).map((row) => [String(row.day), Number(row[key]) || 0]));
  return Array.from({ length: 30 }, (_, i) => byDay.get(new Date(Date.now() - (29 - i) * 86400000).toISOString().slice(0, 10)) ?? 0);
}

/** Quoten, soweit sich aus den Kennzahlen ableiten lassen: SLA, Zuweisung, Fristeinhaltung. */
export function quotasFrom(cards: any, colors: string[]) {
  const quotas: { label: string; percent: number; color: string }[] = [];
  if (cards.slaQuota != null) quotas.push({ label: 'SLA-Quote', percent: cards.slaQuota, color: colors[0] });
  if ((cards.open ?? 0) > 0) {
    quotas.push({ label: 'Zuweisungsquote', percent: ((cards.open - (cards.unassigned ?? 0)) / cards.open) * 100, color: colors[1] });
    quotas.push({ label: 'Fristeinhaltung (offen)', percent: ((cards.open - (cards.overdue ?? 0)) / cards.open) * 100, color: colors[2] });
  }
  return quotas;
}

/** Erledigte Vorgänge je Kalenderwoche samt Trendzeile. */
export function weeksFrom(completedWeekly: any[] | undefined, colors: string[]) {
  const weeks = (completedWeekly ?? []).map((w: any, i: number) => ({
    label: `KW ${isoWeek(new Date(Date.now() - w.weeksAgo * 7 * 86400000))}`,
    value: Number(w.count) || 0,
    color: colors[i % colors.length],
  }));
  const first = weeks[0]?.value ?? 0;
  const last = weeks[weeks.length - 1]?.value ?? 0;
  const trend =
    first > 0
      ? `Trend ${last >= first ? 'steigt' : 'sinkt'} seit ${weeks[0].label} um ${formatPercent(Math.abs(((last - first) / first) * 100))}`
      : 'Abgeschlossene Vorgänge der letzten sechs Wochen';
  return { weeks, trend };
}
